import React from "react";
import { ModeRendererProps } from "./types";

export function VasarelyMiesMode({ brand }: ModeRendererProps) {
  // Less-is-more optics; executive minimalism
  // Thin lines, glass-grid metaphors, negative space
  
  return (
    <g>
      <rect x="0" y="0" width="794" height="1123" fill={brand.white} />
      
      {/* Minimal thin vertical lines - Mies steel frame aesthetic */}
      {Array.from({ length: 15 }).map((_, i) => {
        const x = 80 + i * 44;
        return (
          <line
            key={`vert-${i}`}
            x1={x}
            y1="60"
            x2={x}
            y2="1060"
            stroke={brand.deep}
            strokeWidth="0.5"
            opacity={0.4}
          />
        );
      })}
      
      {/* Minimal horizontal lines */}
      {Array.from({ length: 20 }).map((_, i) => {
        const y = 60 + i * 50;
        return (
          <line
            key={`horiz-${i}`}
            x1="80"
            y1={y}
            x2="720"
            y2={y}
            stroke={brand.deep}
            strokeWidth="0.5"
            opacity={0.4}
          />
        );
      })}
      
      {/* Glass-grid metaphor - subtle reflections */}
      {Array.from({ length: 8 }).map((_, i) =>
        Array.from({ length: 5 }).map((_, j) => {
          const x = 120 + j * 120;
          const y = 100 + i * 120;
          return (
            <rect
              key={`glass-${i}-${j}`}
              x={x}
              y={y}
              width="100"
              height="100"
              fill={brand.aqua}
              opacity={0.02 + (i + j) * 0.01}
              stroke={brand.deep}
              strokeWidth="0.3"
            />
          );
        })
      )}
      
      {/* Vasarely optical accent - single focal point */}
      <g transform="translate(397, 400)">
        {Array.from({ length: 12 }).map((_, i) => {
          const size = 140 - i * 11;
          const offset = i * 5.5;
          return (
            <rect
              key={`optical-${i}`}
              x={-size / 2 + offset}
              y={-size / 2 + offset}
              width={size}
              height={size}
              fill="none"
              stroke={brand.deep}
              strokeWidth="1"
              opacity={0.15 - i * 0.01}
            />
          );
        })}
      </g>
      
      {/* Negative space emphasis - large empty areas */}
      <rect x="150" y="620" width="200" height="140" fill="none" stroke={brand.violet} strokeWidth="1" opacity={0.2} />
      <rect x="450" y="620" width="200" height="140" fill="none" stroke={brand.aqua} strokeWidth="1" opacity={0.2} />
      
      {/* Minimal accent lines - executive precision */}
      <line x1="80" y1="220" x2="720" y2="220" stroke={brand.violet} strokeWidth="2" opacity={0.3} />
      <line x1="80" y1="580" x2="720" y2="580" stroke={brand.aqua} strokeWidth="2" opacity={0.3} />
      <line x1="397" y1="60" x2="397" y2="1060" stroke={brand.amber} strokeWidth="2" opacity={0.3} />
      
      {/* Subtle geometric emphasis */}
      {Array.from({ length: 3 }).map((_, i) => {
        const y = 850 + i * 80;
        return (
          <g key={`accent-${i}`}>
            <line x1="100" y1={y} x2="700" y2={y} stroke={brand.deep} strokeWidth="0.5" opacity={0.5} />
            <circle cx="100" cy={y} r="3" fill={brand.violet} opacity={0.6} />
            <circle cx="700" cy={y} r="3" fill={brand.aqua} opacity={0.6} />
          </g>
        );
      })}
    </g>
  );
}
